// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"eb8a5b1c9de8856884b5","115":"9dfa08709204a78256d4","116":"42c1603de78cf39941dd","164":"f33ad2adedf28bc32b0a","165":"21f0ea7cede7f02fa7c8"}[chunkId] + ".chunk.js";
};